import { collectionMigrationService } from './collectionMigrationService';

/**
 * 컬렉션 마이그레이션 실행 스크립트
 * 브라우저 콘솔에서 실행할 수 있는 전역 함수들
 */

// 전역 함수로 등록
declare global {
  interface Window {
    runCollectionMigration: (userId: string, classId: string) => Promise<void>;
    getCollectionMigrationResult: () => any;
  }
}

/**
 * 컬렉션 마이그레이션 실행
 * @param userId 사용자 ID
 * @param classId 클래스 ID
 */
export async function runCollectionMigration(userId: string, classId: string): Promise<void> {
  try {
    console.log('🚀 컬렉션 마이그레이션 시작...');
    console.log(`사용자: ${userId}`);
    console.log(`클래스: ${classId}`);
    console.log('변경사항: assignments → generalAssignments');
    
    await collectionMigrationService.runCollectionMigration(userId, classId);
    
    const result = collectionMigrationService.getResult();
    console.log('📊 마이그레이션 결과:', result);
    
    if (result.success) {
      console.log('✅ 컬렉션 마이그레이션 성공!');
      console.log(`처리된 과제: ${result.processedCount}개`);
      console.log(`에러: ${result.errorCount}개`);
      console.log(`소요 시간: ${result.duration}ms`);
    } else {
      console.error('❌ 컬렉션 마이그레이션 실패');
      console.error('에러 목록:', result.errors);
    }
  } catch (error) {
    console.error('❌ 컬렉션 마이그레이션 실행 중 오류:', error);
  }
}

/**
 * 마이그레이션 결과 조회
 */
export function getCollectionMigrationResult() {
  return collectionMigrationService.getResult();
}

// 전역 함수로 등록
if (typeof window !== 'undefined') {
  window.runCollectionMigration = runCollectionMigration;
  window.getCollectionMigrationResult = getCollectionMigrationResult;
  
  console.log('🔧 컬렉션 마이그레이션 함수가 전역으로 등록되었습니다.');
  console.log('사용법:');
  console.log('1. runCollectionMigration("userId", "classId") - 컬렉션 마이그레이션 실행');
  console.log('2. getCollectionMigrationResult() - 마이그레이션 결과 조회');
}
